'use client';

import React from 'react';

const GlobalLoader = () => {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 9999,
        
      }}
      className="d-flex justify-content-center align-items-center bg-light"
    >
      <div
        
      >
        <img src="/Saishishir-logo.webp" width="150px" height="70px"/>
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

export default GlobalLoader;
